// Lussera theme JS - minimal interactions
(function(){
  'use strict';

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function(){
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function(){
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Cart count update after add-to-cart submissions (basic)
  var forms = document.querySelectorAll('form[action="/cart/add"]');
  forms.forEach(function(form){
    form.addEventListener('submit', function(e){
      // Let Shopify handle default submission; no custom AJAX required for MVP
    });
  });

  // Sticky header shadow on scroll
  var header = document.querySelector('[data-header]');
  var onScroll = function(){
    if (!header) return;
    if (window.scrollY > 8) {
      header.style.boxShadow = '0 1px 12px rgba(0,0,0,.06)';
    } else {
      header.style.boxShadow = 'none';
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Fade-in on scroll for sections
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.featured-collection, .image-with-text, .testimonials, .faq-section').forEach(function(el){
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
      io.observe(el);
    });
  }

  // ============================
  // Product page variant handling
  // ============================
  var productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    var variantsJsonEl = productSection.querySelector('[data-variants-json]');
    var mediaJsonEl = productSection.querySelector('[data-media-json]');
    if (!variantsJsonEl) return;
    var variants = [];
    var mediaList = [];
    try { variants = JSON.parse(variantsJsonEl.textContent || '[]'); } catch(e){}
    try { mediaList = JSON.parse(mediaJsonEl.textContent || '[]'); } catch(e){}

    var mainImage = productSection.querySelector('[data-main-image]');
    var thumbs = productSection.querySelectorAll('[data-thumb]');
    var variantIdInput = productSection.querySelector('[data-variant-id-input]');
    var priceEl = productSection.querySelector('[data-price]');
    var addBtn = productSection.querySelector('[data-add-to-cart]');
    var addLabel = productSection.querySelector('[data-add-label]');
    var selectedValueEls = productSection.querySelectorAll('[data-selected-value]');
    var optionInputs = productSection.querySelectorAll('[data-option-input]');

    function money(cents) {
      var value = (cents / 100).toFixed(2);
      return '$' + value;
    }

    function getSelectedOptions() {
      var opts = [];
      productSection.querySelectorAll('.variant-group').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input[data-option-input]:checked');
        opts[idx] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function(v){
        return (v.options || []).every(function(val, i){ return val === opts[i]; });
      });
    }

    function findMediaById(id) {
      return mediaList.find(function(m){ return m.id === id; });
    }

    function updateMainImage(src, mediaId) {
      if (mainImage && src) {
        mainImage.style.opacity = '0';
        setTimeout(function(){
          mainImage.src = src;
          mainImage.style.opacity = '1';
        }, 120);
      }
      thumbs.forEach(function(t){
        t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(mediaId));
      });
    }

    function updateSelectedLabels(opts) {
      productSection.querySelectorAll('.variant-group').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var label = group.querySelector('[data-selected-value]');
        if (label && opts[idx]) label.textContent = opts[idx];
      });
    }

    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      updateSelectedLabels(opts);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) { addLabel.textContent = 'Unavailable'; }
        return;
      }
      // Update hidden variant id
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update URL (variant param) without reload
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e){}

      // Update price
      if (priceEl) {
        var priceHtml = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml = '<span class="price-compare">' + money(variant.compare_at_price) + '</span> <span class="price-sale">' + money(variant.price) + '</span>';
        } else {
          priceHtml = '<span class="price">' + money(variant.price) + '</span>';
        }
        priceEl.innerHTML = priceHtml;
      }

      // Update add-to-cart state
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      // Update main image if variant has a featured image
      if (variant.featured_media && variant.featured_media.preview_image) {
        var previewSrc = variant.featured_media.preview_image.src;
        // Try to find full-size media by id
        var media = findMediaById(variant.featured_media.id);
        var finalSrc = media && media.preview_image ? media.preview_image.src : previewSrc;
        // Append width param if it's a Shopify CDN URL
        if (finalSrc && finalSrc.indexOf('cdn.shopify.com') !== -1 && finalSrc.indexOf('width=') === -1) {
          finalSrc = finalSrc + (finalSrc.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
        }
        updateMainImage(finalSrc, variant.featured_media.id);
      } else if (variant.featured_image && variant.featured_image.src) {
        updateMainImage(variant.featured_image.src, variant.featured_image.id);
      }
    }

    optionInputs.forEach(function(input){
      input.addEventListener('change', updateVariant);
    });

    // Thumbnail click
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        var src = thumb.getAttribute('data-image');
        var mid = thumb.getAttribute('data-media-id');
        updateMainImage(src, mid);
      });
    });
  }
})();
